import React from 'react';
import { get } from 'lodash';
import axios from 'axios';

import {
  addNotification,
  requestCallback,
} from '../lib/helpers';

import Notification from './Notification';

class ToggleRecommendUser extends React.Component {
  static defaultProps = {
    klassName: 'User__header__recommend',
    hideText: false,
  }

  makeRecommend = () => {
    requestCallback(axios.get(`/${gon.currentProvider}/api/users/${get(this.props, 'userId')}/make_recommend`))
  }

  unrecommend = () => {
    requestCallback(axios.get(`/${gon.currentProvider}/api/users/${get(this.props, 'userId')}/unrecommend`))
  }

  render() {
    return (
      <React.Fragment>
        {get(this.props, 'isRecommend') ?
          <a
            className='User__header__recommend User__header__recommend--unrecommend'
            onClick={this.unrecommend}
          >
            Unrecommend
          </a>
        :
          <a
            className={get(this.props, 'klassName')}
            onClick={this.makeRecommend}
          >
            {!get(this.props, 'hideText') && 'Recommend'}
          </a>
        }
      </React.Fragment>
    );
  }
}

export default ToggleRecommendUser
